"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asAnnotation = asAnnotation;
exports.isAnnotation = isAnnotation;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function asAnnotation(thing) {
  if (_typeof(thing) === 'object' && thing !== null) {
    if (thing.type === 'ObjectAnnotation') {
      return thing;
    } else if (thing.type === 'ArrayAnnotation') {
      return thing;
    } else if (thing.type === 'ScalarAnnotation') {
      return thing;
    } else if (thing.type === 'FunctionAnnotation') {
      return thing;
    } else if (thing.type === 'CircularRefAnnotation') {
      return thing;
    }
  }
  return undefined;
}
function isAnnotation(thing) {
  return asAnnotation(thing) !== undefined;
}